import { render, staticRenderFns } from "./PatientCreate.vue?vue&type=template&id=b30e7ad6&"
import script from "./PatientCreate.vue?vue&type=script&lang=js&"
export * from "./PatientCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports